// extracted by mini-css-extract-plugin
export default {"title":"F1KzTxVT","_isSuccessPage":"r0i7qEUb","mobile":"mobile","envelope":"wi_rDY8j","phone":"yMM8cvDJ"};